module.exports = __webpack_public_path__ + "assets/update.32f11f51.svg";